import { FC, ReactElement, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { getToken } from "../utils";

export const AccessTokenGuard: FC<{ children: ReactElement }> = ({
  children,
}) => {
  const { accessToken } = getToken();
  const history = useHistory();

  useEffect(() => {
    if (!accessToken) {
      history.push("/auth/login");
    }
  }, [accessToken, history]);

  return accessToken ? children : null;
};
